var App = App || {};

App.WidgetForm = (function ($) {
    'use strict';

    function Init(selector) {
        if (selector.length) {
            selector.each(function () {
                var $this = $(this),
                    $form = $this.find("form"),
                    pageTitle = $("title").text().split(" |")[0],
                    hiddenInput = $this.find('input[type="hidden"]');

                // make file uploader "delete file" link keyboard accessible
                $form
                    .find(".ktc-uploader-text-button")
                    .attr("href", "#")
                    .on("click", function (e) { e.preventDefault(); });

                // if the form has been modified for custom validation, send it that way
                if ($form.is("[data-zag-validate-form]")) {
                    App.SharedFormValidation.Init($form);
                }

                $.each(hiddenInput, function () {
                    var $this = $(this),
                        id = $this.attr("id");

                    if (typeof id == "string" && id.indexOf("PageTitle") !== -1) {
                        // Hide the hidden input's label from the frontend
                        $form.find("label[for='" + id + "']").hide();

                        // Set the value of the hidden input to the page title
                        $("#" + id).val(pageTitle);
                    }
                })
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);